// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__Xtw11","footerInner":"style_footerInner__nsFgH","logo":"style_logo__Usg2z"};